<!-- 学习服务-图文-我的已购 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img">
				<p class="header-title">我的已购</p>
			</div>
			<div class="search-box">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input type="search" value="" placeholder="请输入关键字进行搜索" class="search-input" disabled />
				</div>
			</div>
		</div>

		<ul class="list">
			<li>
				<div class="img-box">
					<img src="../assets/img.png" class="img">
					<span class="tag-black">02:34</span>
				</div>
				<div class="item-sidebar">
					<p class="item-name">AP AUTOSAR & 自动驾驶：等方面进行分享。</p>
				</div>
			</li>
			<!-- 暂无数据展示 -->
			<div class="normal-box-small">
				<img src="../assets/normal-8.png">
				暂无数据
			</div>
		</ul>



	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				showReport: false,
				showOpenVip: false,
				status: 0
				// 举报参数
				// reportParams: {
				// 	type: 5, // 举报类型（1视频2视频评论3会员,4资料,5图文）
				// 	report_id: 0, // 举报内容的id
				// },
				// params: {
				// 	title: '', // 标题
				// 	sort_type: 1, // 1默认2时间升序3时间降序
				// 	page: 1, // 页数
				// 	page_num: 20, // 每页数
				// },
				// list: [],
				// loading: false,
				// finished: false,

				// isLogin: false,
				// isVip: false,
			};
		},
		mounted() {},
		methods: {},
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 102px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		height: 58px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-bar {
		flex: 1;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 14px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}




	.wrap {
		width: 100%;
		height: calc(100vh - 102px);
		display: flex;
		flex-direction: row;
		margin: 102px 0 0;
		box-sizing: border-box;
		background: linear-gradient(180deg, #FFFFFF, #F3F3F3);
		overflow-y: auto;
	}

	.wrap-tab-list-none {
		height: calc(100vh - 90px);
		margin: 90px 0 0;
	}


	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
		/*height: 100%;*/
		overflow: auto;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 10px;
		box-sizing: border-box;
		position: relative;
	}


	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.float-box {
		position: fixed;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: 40px;
		z-index: 499;
	}

	.float-box>button {
		min-width: 175px;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #2A63F3;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 5px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 12px;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		padding: 12px 10px;
		box-sizing: border-box;
		position: relative;
	}

	.img-box {
		width: 104px;
		height: 72px;
		position: relative;
		margin-right: 14px;
	}

	.img {
		width: 100%;
		height: 100%;
		border-radius: 7px;
		object-fit: cover;
	}

	.tag {
		width: 34px;
		height: 14px;
		line-height: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(90deg, #FFCD7C, #FFEEBA);
		border-radius: 0 7px 0 7px;
		color: #222222;
		font-size: 12px;
		font-weight: bold;
		position: absolute;
		right: 0;
		top: 0;
	}

	.tag-black {
		width: 34px;
		height: 14px;
		line-height: 14px;
		background: rgba(0, 0, 0, 0.8);
		border-radius: 50px;
		color: #FFFFFF;
		font-size: 9px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		right: 10px;
		bottom: 10px;
	}

	.item-sidebar {
		flex: 1;
		height: 70px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-name {
		width: 100%;
		line-height: 21px;
		color: #222222;
		font-size: 15px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.row {
		width: 100%;
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.avatar {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		margin-right: 4px;
		object-fit: cover;
	}

	.row2 {
		width: 100%;
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.play-icon {
		width: 12px;
		margin-right: 4px;
	}

	.circle-btn {
		width: 13px;
		height: 13px;
		position: absolute;
		right: 10px;
		bottom: 9px;
	}

	.circle-icon {
		width: 13px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 16px;
		color: #888888;
		padding: 48px 0;
	}

	.normal-box-small>img {
		width: 195.2px;
		margin-bottom: 38px;
	}
</style>
